import {Column,Entity,PrimaryGeneratedColumn,VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('stock_log')
export class StockLog {

    @PrimaryGeneratedColumn("increment",{name:'stock_log_id'})
    stockLogId:number;

    @Column("varchar", {
        nullable: false,
        name: "purpose",
        length:100,
    })
    purpose: string;

    @Column("int", {
    nullable: false,
    name: "stock_id"
    })
    stockId: number;
    @Column("int", {
        nullable: false,
        name: "plant_id"
        })
        plantId: number;
    @Column("int", {
        nullable: true,
        name: "old_rack_position_id"
        })
    oldRackPositiontId: number;
    @Column("int", {
        nullable: true,
        name: "updated_rack_position_id"
        })
    updatedRackPositionId: number;
    @Column("int", {
        nullable: true,
        name: "old_plant_id"
        })
    oldPlantId: number;
    @Column("int", {
        nullable: true,
        name: "updated_plant_id"
        })
    updatedPlantId: number;
    @Column("int", {
        nullable: true,
        name: "old_so_id"
        })
    oldSoId: number;
    @Column("int", {
        nullable: true,
        name: "updated_so_id"
        })
    updatedSoId: number;
    @Column("int", {
        nullable: true,
        name: "old_so_item_id"
        })
    oldSoItemId: number;
    @Column("int", {
        nullable: true,
        name: "updated_so_item_id"
        })
    updatedSoItemId: number;

    @Column("int", {
        nullable: false,
        name: "cartons"
        })
    cartons: number;

    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
      })
      createdAt: Date;
    
      @Column("varchar", {
          nullable: true,
          name: "created_user",
          length:50,
          default:"Admin",
      })
      createdUser: string | null;
    
    
      @UpdateDateColumn({
          name: "updated_at",
          type:'datetime'
      })
      updatedAt: Date;
    
      @Column("varchar", {
          nullable: true,
          name: "updated_user",
          length:50
      })
      updatedUser: string | null;
    
      @VersionColumn({
          default:1,
          name: "version_flag"
      })
      versionFlag: number;
}
